export default {
    baseStyle: {
        wrapper: {
            flex: '0 0 100%',
            gap: '10px',
            paddingX: '15px',
            minHeight: {base: '113px', md: '78px', lg: '78px'},
            paddingTop: '10px',
            paddingBottom: '15px',
            borderRadius: '5px',
            border: '1px solid',
            borderColor: 'gray.500',
            background: 'white'
        },
        sliderWrapper: {
            position: 'relative',
            flex: '1',
            zIndex: '0',
            paddingBottom: '25px',
            sx: {
                '.chakra-step:first-of-type': {
                    marginLeft: '-21px' // Width of initial green indicator on empty BMSM
                }
            }
        }
    },
    sizes: {
        pdp: {
            wrapper: {
                marginTop: '0px'
            },
            header: {
                flexDirection: 'row',
                width: 'full',
                justifyContent: 'space-between'
            }
        },
        cart: {
            wrapper: {
                gap: {base: 3, lg: '35px'},
                flexDirection: {base: 'column', lg: 'row'},
                maxWidth: '100%',
                padding: '0px'
            },
            header: {
                flexDirection: {base: 'row', lg: 'column'},
                width: {base: 'full', lg: 'max-content'},
                justifyContent: {base: 'space-between', lg: 'start'},
                gap: 0
            },
            sliderWrapper: {
                paddingBottom: {base: '25px', lg: '20px'},
                width: {base: '95%', lg: '100%'}
            }
        },
        plp: {
            wrapper: {
                gap: {base: 3, lg: '35px'},
                flexDirection: {base: 'column', lg: 'row'},
                marginX: {base: '15px', lg: '60px'},
                marginTop: '15px',
                marginBottom: {base: '15px', lg: '0px'},
                maxWidth: '900px',
                paddingX: {base: '15px', lg: '30px'}
            },
            header: {
                flexDirection: {base: 'row', lg: 'column'},
                width: {base: 'full', lg: 'max-content'},
                justifyContent: {base: 'space-between', lg: 'start'},
                gap: 0
            },
            sliderWrapper: {
                paddingBottom: {base: '25px', lg: '20px'}
            }
        }
    },
    parts: ['wrapper', 'header', 'sliderWrapper'],
    defaultProps: {
        size: 'pdp'
    }
}
